export const commonResources = {
  'common.logout': '登出',
};

export type CommonResourceKey = 'common.logout';
